export const FETCH_CANCEL_SUBSCRIPTION_LOADING =
  "FETCH_CANCEL_SUBSCRIPTION_LOADING";
export const FETCH_CANCEL_SUBSCRIPTION = "FETCH_CANCEL_SUBSCRIPTION";
export const FETCH_CANCEL_SUBSCRIPTION_ERROR =
  "FETCH_CANCEL_SUBSCRIPTION_ERROR";
